import React,{useState,useEffect} from "react";
import {
    Box,
    Popover,
    Typography,
    IconButton,
    Button,
    Badge,
    Grid,
    Tooltip,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemAvatar,
    Avatar,
    DialogContent,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CircleIcon from "@mui/icons-material/Circle";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useSelector } from "react-redux";
import { RootState } from "../../store/reducers";
import { Link } from "react-router-dom";
import { useData,useInterval } from "@pure-ptr/react";
import { getAllNotifications, getUnreadCount, markAllRead, markUnread, markRead,markAllUnread } from "../../store/api/notificationsSubscriptions";
import { formatDateTimeLocal } from "../../util/date";
import { Loadable } from "../loadable";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUnreadCount } from "../../store/actions/notifications";
import { convertDateToLocal } from "../../util/date";

const topBarStyles = {
    fontWeight: 500,
    display: 'block',
};
export const hypeLinksEnums={fee:"Fee Schedule",Rules:"Rule"}

export const createDeepLink = (item, page) => {
    const jsonPayload = JSON.parse(item?.payloadJson || "{}");
    if (page.includes("rule")) {
           return `/cms/contract/${jsonPayload?.Contract?.Id || jsonPayload?.ContractStateId}/rule/${jsonPayload?.ContractServiceId}/edit/${jsonPayload?.Id}/${jsonPayload?.ContractDirectoryId || "root"}/true`;
    }

    if (page?.toLowerCase()?.includes("contract")) {
        return `/cms/contract/view/${jsonPayload?.Id}`;
    }
    if (page?.toLowerCase()?.includes("fee")) {
        return `/cms/feeschedules/edit/-1/${
            jsonPayload?.Id
        }`;
    }

    return "/";
};

export const getHyperLinkTitle = (item) => item?.split("_")[0].toLowerCase()

export default function BasicPopover() {
    const dispatch=useDispatch()
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(
        null
    );

    const currentClientId: any = useSelector<RootState>(
    state => state?.session?.user?.preferredDashboardClientId
    );

    const unreadCount = useSelector<RootState>(
        state => (state as any).notifications?.unreadCount
    ) as number;


    const [anchorElOptions, setAnchorElOptions] = useState<HTMLButtonElement | null>(
        null
    );

    const { data: unreadCountData, reload: reloadUnreadCount } = useData(() => getUnreadCount([currentClientId]), [currentClientId]);
    const notificationsCount = (unreadCount as number > 99 ? '99+':unreadCount) ?? 0;

    const [prevUnreadCount, setPrevUnreadCount] = useState<number | null>(null);
    const [isShaking, setIsShaking] = useState(false);

    const [notificationsList, setNotificationsList] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const listRef = React.useRef<any>(null);

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

        const {
        data: notificationsPageData,
        isPending: loading,
        reload,
    } = useData(async () => {
        return getAllNotifications({
            sort: [{ id: 'notification.createdAt', direction: 'desc' }],
            filter: {
                "operands": [
                    {
                        "operator": "and",
                        "filters": [
                            {
                                "id": "notification.clientId",
                                "equator": "equals",
                                "value": currentClientId
                            }
                        ]
                    },
                    {
                        "operator": "and",
                        "filters": [
                            {
                                "id": "isRead",
                                "equator": "equals",
                                "value": false
                            }
                        ]
                    }
                ]
            },
            page: { currentPage: page, recordsPerPage: 10 },
        });
    }, [page]);



    const [markReadId, setMarkReadId] = useState(null);
    const { isPending: isMarkReadPending } = useData(async () => {
        if (!markReadId) return;
        await markRead([markReadId]);
        setNotificationsList((prev) =>
            prev.map((n) => (n.notificationId === markReadId ? { ...n, isRead: true } : n))
        );
        setMarkReadId(null);
        reloadUnreadCount();
    }, [markReadId]);

    const [markUnreadId, setMarkUnreadId] = useState(null);
    const { isPending: isMarkUnreadPending } = useData(async () => {
        if (!markUnreadId) return;
        await markUnread([markUnreadId]);
        setNotificationsList((prev) =>
            prev.map((n) => (n.notificationId === markUnreadId ? { ...n, isRead: false } : n))
        );
        setMarkUnreadId(null);
        reloadUnreadCount();
    }, [markUnreadId]);

    const [markAllReadTrigger, setMarkAllReadTrigger] = useState(0);
    const { isPending: isMarkAllReadPending } = useData(async () => {
        if (markAllReadTrigger === 0) return;
        await markAllRead([currentClientId]);
        setNotificationsList((prev) =>
            prev.map((item) => ({ ...item, isRead: true }))
        );
        reloadUnreadCount();
    }, [markAllReadTrigger]);

    const [markAllUnreadTrigger, setMarkAllUnreadTrigger] = useState(0);
    const { isPending: isMarkAllUnreadPending } = useData(async () => {
        if (markAllUnreadTrigger === 0) return;
        
        await markAllUnread([currentClientId]);
        if (notificationsList.length === 0) {
            reload();
        } else {
            setNotificationsList((prev) =>
                prev.map((item) => ({ ...item, isRead: false }))
            );
        }
        reloadUnreadCount();
    }, [markAllUnreadTrigger]);


    const handleToggleRead = (item) => {
        if (item.isRead) {
            setMarkUnreadId(item.notificationId);
        } else {
            setMarkReadId(item.notificationId);
        }
    };

    const handleMarkAllRead = () => {
        if (notificationsCount === 0) {
            setMarkAllUnreadTrigger(prev => prev + 1);
        } else {
            setMarkAllReadTrigger(prev => prev + 1);
        }
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const IsShowLink = (item) => {
     var json = JSON.parse(item.notification?.payloadJson);
     if(json.ShowLink != undefined){
        return json.ShowLink;
     }
     return true;
    }

    const IsShowIcon = (item) => {
     var json = JSON.parse(item.notification?.payloadJson);
     if(json.ShowIcon != undefined){
        return json.ShowIcon;
     }
     return false;
    }


    const getNotificationText = (item) => {
    var json = JSON.parse(item.notification?.payloadJson);
     if(json.MessageText != undefined){
        return json.MessageText;
     }
     return '';
    }

    const handleClickOptions = (event) => {
        setAnchorElOptions(event.currentTarget);
    };

    const handleCloseOptions = () => {
        setAnchorElOptions(null);
    };

    const openHambug = Boolean(anchorElOptions);
    const idHamburg = open ? 'simple-popover-hambburg' : undefined;

    const topOptions = [
        { label: "View All Notifications", breakpoint: 3, onClick: () => {
            handleClose()
            handleCloseOptions()
                history.push("/all-notifications");
            
        } },
        { label: notificationsCount === 0 ? "Mark All As Unread" : "Mark All As Read", breakpoint: 3, onClick: handleMarkAllRead },
    ];

    useEffect(() => {
        if (notificationsPageData?.results) {
            if (page === 1) {
                setNotificationsList(notificationsPageData.results);
            } else {
                setNotificationsList((prev) => {
                    return [...prev, ...notificationsPageData.results];
                });
            }
            setHasMore(notificationsPageData.results.length === 10);
        }
    }, [notificationsPageData]);

    useEffect(() => {
        if (open) {
            setPage(1);
            setHasMore(true);
            setNotificationsList([]);
            reload();
        }
    }, [open]);

    useEffect(() => {
        if (unreadCountData !== undefined && unreadCountData !== null) {
            dispatch(setUnreadCount(unreadCountData));
        }
    }, [unreadCountData, dispatch]);


    useEffect(() => {
        if (typeof unreadCount === 'number' && unreadCount !== null) {
            if (prevUnreadCount !== null && unreadCount > prevUnreadCount) {
                setIsShaking(true);
                setTimeout(() => setIsShaking(false), 500); 
            }
            setPrevUnreadCount(unreadCount);
        }
    }, [unreadCount]);

    useInterval(reloadUnreadCount, 60000);
    
    const handleScroll = () => {
        const list = listRef.current;
        if (!list || !hasMore || loading) return;

        if (list.scrollTop + list.clientHeight >= list.scrollHeight - 10) {
            const nextPage = page + 1;
            setPage(nextPage);
        }
    };

    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = "#";

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }

        return color;
    }

    function stringAvatar(name) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
        };
    }

    const renderAvatar = (item) => {
        const category = item?.notification?.category?.toLowerCase() || "";
        const title = item?.notification?.title ?? "Notification";
        const bgcolor = stringToColor(title);

        if (category.includes("contract") || category.includes("rule")) {
            return (
                <Avatar sx={{ bgcolor }}>
                    <i className="far fa-handshake"></i>
                </Avatar>
            );
        } else if (category.includes("fee")) {
            return (
                <Avatar sx={{ bgcolor }}>
                    <i className="flaticon-interface-3"></i>
                </Avatar>
            );
        } else {
            return <Avatar {...stringAvatar(title)} />;
        }
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            <IconButton onClick={handleClick} className={isShaking ? "shake" : ""}>
                <Badge badgeContent={notificationsCount} color="error">
                    <NotificationsIcon />
                </Badge>
            </IconButton>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                PaperProps={{
                    sx: {
                        width: 500,
                        padding: 2,
                        maxHeight: 600,
                        overflow: "hidden",
                    },
                }}
            >
                <Loadable
                    loading={
                        isMarkReadPending != null ||
                        isMarkUnreadPending != null ||
                        isMarkAllReadPending != null ||
                        isMarkAllUnreadPending != null
                    }
                >
                    <Grid container sx={{ mb: "10px" }}>
                        <Grid item xs={5} alignContent={"center"}>
                            <Typography variant="h6">Notifications</Typography>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            alignContent={"center"}
                            textAlign={"right"}
                        ></Grid>

                        <Grid
                            item
                            xs={1}
                            textAlign={"right"}
                            alignContent={"center"}
                            alignItems={"right"}
                        >
                            <Button
                                variant="text"
                                aria-describedby={idHamburg}
                                onClick={handleClickOptions}
                                sx={{
                                    "&:hover": { borderRadius: "50%" },
                                    minWidth: "10px !important",
                                }}
                            >
                                <MoreVertIcon />{" "}
                            </Button>

                            <Popover
                                id={idHamburg}
                                open={openHambug}
                                anchorEl={anchorElOptions}
                                onClose={handleCloseOptions}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                            >
                                <DialogContent>
                                    {topOptions?.map((item) => (
                                        <Typography
                                            sx={{
                                                ...topBarStyles,
                                                lineHeight: "30px",
                                                cursor: "pointer",
                                                '&:hover': { textDecoration: 'underline' }
                                            }}
                                            onClick={() => item?.onClick()}
                                        >
                                            {item?.label}
                                        </Typography>
                                    ))}
                                </DialogContent>{" "}
                            </Popover>
                        </Grid>
                    </Grid>

                    <Divider />

                    {(!loading && (notificationsList?.length === 0 || unreadCount==0)) ? (
                        <Box
                            sx={{
                                width: "100%",
                                bgcolor: "background.paper",
                                height: 550,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Typography>No Notifications Found</Typography>
                        </Box>
                    ) : (
                        <List
                            ref={listRef}
                            onScroll={handleScroll}
                            dense
                            sx={{
                                width: "100%",
                                bgcolor: "background.paper",
                                height: 550,
                                overflowY: "auto",
                            }}
                        >
                        {notificationsList?.map((item, index) => (
                            !item?.isRead && <ListItem key={item.id} disablePadding>
                                <ListItemButton>
                                    <ListItemAvatar>
                                        {renderAvatar(item)}
                                    </ListItemAvatar>

                                    <ListItemText
                                        primary={
                                            <Box
                                                component="span"
                                                sx={{
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {item?.notification?.title?.toLowerCase()}
                                            </Box>
                                        }
                                        sx={{
                                            "& .MuiTypography-root": {
                                                textTransform: "capitalize",
                                            },
                                            paddingRight: "15px",
                                        }}
                                        secondary={
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                gap={0.5}
                                                mt={1}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    component="span"
                                                    color="text.primary"
                                                    dangerouslySetInnerHTML={{
                                                        __html: item?.notification?.body || getNotificationText(item)
                                                    }}
                                                />
                                                {IsShowLink(item)                                                
                                                &&
                                                (<Link
                                                    style={{
                                                        ...topBarStyles,
                                                        textTransform:
                                                            "capitalize",
                                                    }}
                                                    onClick={() => {
                                                        handleClose()
                                                        handleCloseOptions()
                                                    }}
                                                    to={createDeepLink(
                                                        item?.notification,
                                                        getHyperLinkTitle(
                                                            item
                                                                .notification
                                                                .category
                                                        )
                                                    )}
                                                >
                                                    Review{" "}
                                                    {item?.notification
                                                            ?.category
                                                            ? hypeLinksEnums[
                                                                  getHyperLinkTitle(
                                                                      item
                                                                          .notification
                                                                          .category
                                                                  )
                                                              ] ||
                                                              getHyperLinkTitle(
                                                                  item
                                                                      .notification
                                                                      .category
                                                              )
                                                            : "Item"}
                                                </Link>)
                                            }
                                                
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                    sx={{textTransform:'lowercase !important'}}
                                                >
                                                    {convertDateToLocal(
                                                        item?.notification
                                                            ?.createdAt
                                                    )}
                                                </Typography>
                                            </Box>
                                        }
                                    />
                                    {IsShowIcon(item) &&
                                    <Tooltip
                                        title={
                                            item?.notification?.severity === "HIGH"
                                                ? "Warning"
                                                : item?.notification?.severity === "CRITICAL" ? "Error" : "Completed"
                                        }
                                    >
                                        <IconButton
                                            sx={{
                                                padding: "5px",
                                                border: "1px solid transparent",
                                                "&:hover": {
                                                    borderColor: "lightgray",
                                                },
                                            }}
                                            onClick={(e) => { }}
                                        >
                                            {item?.notification?.severity === "HIGH" ? (
                                                <WarningIcon                                                    
                                                    sx={{ color:"orange", fontSize: "12px" }}
                                                />
                                            ) : item?.notification?.severity === "CRITICAL" ? (
                                                <ErrorIcon
                                                    sx={{ color: "red", fontSize: "12px" }}
                                                />
                                            ):(
                                                <CheckCircleIcon
                                                    sx={{ color: "green", fontSize: "12px" }}
                                                />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                     }
                                    
                                    <Tooltip
                                        title={
                                            item?.isRead
                                                ? "Mark As Unread"
                                                : "Mark As Read"
                                        }
                                    >
                                        <IconButton
                                            sx={{
                                                padding: "5px",
                                                border: "1px solid transparent",
                                                "&:hover": {
                                                    borderColor: "lightgray",
                                                },
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleToggleRead(item);
                                            }}
                                        >
                                            {!item?.isRead ? (
                                                <CircleIcon
                                                    color="primary"
                                                    sx={{ fontSize: "12px" }}
                                                />
                                            ) : (
                                                <RadioButtonUncheckedIcon
                                                    color="primary"
                                                    sx={{ fontSize: "12px" }}
                                                />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                </ListItemButton>
                            </ListItem>
                        ))}

                        {loading != null && hasMore && (
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    py: 1,
                                    color: "gray",
                                    fontSize: 13,
                                }}
                            >
                                Loading...
                            </Typography>
                        )}
                        </List>
                    )}
                </Loadable>
            </Popover>
        </Box>
    );
}
